import MobileBathFragranceSection from './MobileBathFragranceSection';

export default MobileBathFragranceSection;
